/** Feature flag keys. Must match `FeatureFlagKeys` in the backend and the key created in the Hub. */
export const FEATURE_FLAGS = {
  MerchantDashboard: "merchant-dashboard",
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

export type FeatureFlags = Record<string, boolean>;

/** A flag that is missing (not created in the Hub, or flags failed to load) is off. */
export const isFeatureEnabled = (flags: FeatureFlags | null | undefined, key: FeatureFlagKey): boolean =>
  flags?.[key] === true;

/** The dashboard needs both the per-user grant and the global `merchant-dashboard` flag. */
export const canAccessDashboard = (
  user: { hasDashboardAccess: boolean; featureFlags: FeatureFlags } | null | undefined,
): boolean => !!user?.hasDashboardAccess && isFeatureEnabled(user.featureFlags, FEATURE_FLAGS.MerchantDashboard);
